<template>
  <div class="">
    <input class="form-control text-right mb-4 mt-4 AdvSearch" id="Adv-Search" @input="Search($event)" @focus="Search($event)" v-model="Txt" type="text" dir="ltr"
     placeholder=" جستــــجو پیشرفته" @click.prevent="OpenSearch()" :title="Title" />
    <i class="fas fa-search"></i>
    <div class="Box_Result Rounded p-2 AdvSearch" dir="rtl" v-if="Result">
      <p v-if="Load">درحال بارگزاری اطلاعات ...</p>
      <div class="AdvSearch" v-if="Customer.length >= 1">
        <small class="text-warning"><i class="fad fa-user-tie ml-2"></i></small>
        <small class="text-warning">مشتریان</small>
        <div class="border-right my-3 border-warning px-2 Pointer" v-for="(item, index) in Customer" :key="index" @click="GotoDetailCustomer(item.id)">
          <small class="ml-2 text-warning font-weight-normal">{{ item.customerCode }}</small>

          <small :style="[1664,1656,1312].includes(item.tblCombogrp37AxarinVazeit) ? 'color: #fd5f00 !important;' : ''"
          :title="item.customerName">{{ item.customerName.slice(0, 30) }} ... </small>
        </div>
      </div>
      <div class="AdvSearch" v-if="Ticket.length >= 1">
        <small class="text-warning"><i class="fad fa-user-headset ml-2"></i></small>
        <small class="text-warning">تیکت ها</small>
        <div class="border-right my-3 border-warning px-2 Pointer" v-for="(item, index) in Ticket" :key="index" @click="GotoDetailTicket(item)">
          <small class="ml-2 text-dark font-weight-normal badge-warning px-1 Rounded">{{ item.CustomerCode }}</small>
          <small :style="[1664,1656,1312].includes(item.tblCombogrp37AxarinVazeit) ? 'color: #fd5f00 !important;' : ''"
           :title="item.customerName">{{ item.CustomerName.slice(0, 30) }} ... </small>
          <small class="d-block mt-2">
            {{ item.Title }}
          </small>
          <small class="text-primary mt-2 d-inline"> {{ item.NameGrp41 }} - </small>
          <small class="text-warning mt-2 d-inline"> [ {{ item.DepartmentName }} ] </small>
          <small class="text-primary mt-2 d-inline"> - {{ item.UserNameFam }} </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Title: 'جستجوی شماره مشتری   @ \n جستجوی شماره تیکت  # \n و جستجوی نام مشتری درحالت معمول تایپ کتید',
      Result: false,
      Txt: '',
      Customer: [],
      Personel: [],
      Ticket: [],
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_comboDepUser: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_Users: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      Load: false,
    }
  },
  created() {},
  methods: {
    OpenSearch() {},
    Search(e) {
      this.Load = true
      this.Customer = []
      this.Ticket = []
      this.Personel = []
      let options = []
      let options2 = []
      let options3 = []
      let value2 = []
      let value3 = []
      if (e.target.value.trim().slice(0, 1) === '#') {
        if (e.target.value.length > 3) {
          this.SearchTicket(e.target.value)
        }
      } else if (e.target.value.trim().slice(0, 1) === '@') {
        if (e.target.value.length > 1) {
          var DataAxiosSearch = {
            Action: 'TblCustomerCrm/AdvanceSearchCustomer',
            Method: 'POST',
            ArryfildValue: {
              CustCode: this.Txt.split('@')[1],
              Allfields: '',
              BazaryabiCode: null,
              tblCombogrp11Shahr: null,
              tblCombogrp10state: null,
              tblTicketId: null,
            },
          }
          this.$PostData(DataAxiosSearch).then((result) => {
            this.Load = false
            this.Customer = result
            this.Result = true
            this.Ticket = []
          })
        }
      } else {
        if (e.target.value.length > 3) {
          var DataAxiosSearch = {
            Action: 'TblCustomerCrm/AdvanceSearchCustomer',
            Method: 'POST',
            ArryfildValue: {
              CustCode: '',
              Allfields: this.Txt.trim(),
              BazaryabiCode: null,
              tblCombogrp11Shahr: null,
              tblCombogrp10state: null,
              tblTicketId: null,
            },
          }
          this.$PostData(DataAxiosSearch).then((result) => {
            this.Load = false
            this.Customer = result
            this.Result = true
            this.Ticket = []
          })
        }
      }
    },
    GotoDetailCustomer(item) {
      if (this.$route.name != 'DetailCustomer') {
        // this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: item } })
        this.$FindeCustomerById('DetailCustomer', item, false, null)
      } else {
        this.$router.push({ name: 'MiddPage', params: { ItemsParams: item, NextPage: 'DetailCustomer' } })

        //     this.$GetCustomerDetail(item).then((data)=>{
        //     this.$store.state.Customer = data;
        //     this.$store.state.renderComponentGrid = false
        //     this.$nextTick(() => {
        //         this.$store.state.renderComponentGrid = true
        //         this.$store.state.renderComponentCard = true
        //         this.$CalcBedehiCustomer(this.$store.state.Customer.Customer.Id).then((result) => {
        //             this.$store.state.DetailBedehiCustomer = result[0]
        //         })
        //     })
        // })
      }
      this.Result = false
    },
    GotoDetailTicket(item) {
      if (this.$route.name == 'ChatRoom') {
        this.$router.push({ name: 'MiddPage', params: { ItemsParams: item, NextPage: 'Ticket' } })
      } else {
        this.$router.push({
          name: 'ChatRoom',
          params: {
            // chatRoomId: item.TblChatRoomId,
            // ticketManagerTblUserId: item.TblUserId,
            ticketId: item.Id,
            // tblComboIdTicketStatus: item.TblComboGrpId41,
            // departmentId: item.TblDepartmentId,
            // customerName: item.CustomerName,
            // customerCode: item.CustomerCode,
            // tblCustomerId: item.TblCustomerId,
            // tblComboGrpId42: item.TblComboGrpId42,
            // tblComboGrpId45: item.TblComboGrpId45,
          },
        })
      }
    },
    Clickhandler(e) {
      if (!e.target.classList.contains('AdvSearch')) {
        this.Result = false
      }
    },
    SearchTicket(e) {
      let event=e.replace('#','');
      this.Load = false
      var formData = new FormData()
      formData.append('Id',event)
      var DataAxios = { Method: 'POST', Action: 'Ticket/GetTicketAdvanceSearch', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((response) => {
        this.Ticket=response
          this.Result = true
        })
        .catch((error) => {
          console.error('CATCH', error)
        })
    },
  },
  mounted() {
    window.addEventListener('click', this.Clickhandler)
  },
}
</script>
<style scoped>
.Box_Result {
  width: 16vw !important;
  height: 250px !important;
  background: var(--sidebar-bg-color);
  color: var(--sidebar-color-item);
  position: absolute !important;
  /* border:1px solid var(--sidebar-color-item); */
  border-radius: 15px;
  overflow-y: auto;
  -webkit-box-shadow: -2px 1px 15px 2px rgba(151, 151, 151, 0.44);
  box-shadow: -2px 1px 15px 2px rgba(151, 151, 151, 0.44);
}
input {
  position: relative;
  /* width: 500px !important; */
  border: none !important;
  /* border-bottom:2px solid #ff9800 !important; */
  border-bottom: 2px solid var(--logo-color) !important;
}
.fa-search {
  position: absolute;
  top: 20px;
  right: 280px;
  color: var(--logo-color);
}
.Rounded {
  border-radius: 4px;
}
</style>
